namespace TabAurous {
    export interface KeyRequest extends Serenity.ServiceRequest {
        AppName?: string;
        ClientId?: string;
        Secret?: string;
        APIKey?: string;
        Role?: string;
    }
}
